import { OnboardingHub } from "@/features/onboarding/components/onboarding-hub";

/** First-login "Getting started" hub for firm owners, rendered inside the app
 * shell (see OnboardingGate). */
export default function OnboardingPage() {
  return <OnboardingHub />;
}
